import { render, staticRenderFns } from "./viewSector.vue?vue&type=template&id=77fe64d7"
import script from "./viewSector.vue?vue&type=script&lang=js"
export * from "./viewSector.vue?vue&type=script&lang=js"
import style0 from "./viewSector.vue?vue&type=style&index=0&id=77fe64d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports